import { get } from "./client";
import { ApiEndpoint } from "./endpoints";

export interface Area {
	id: string;
	name: string;
	sortIndex: number;
}

export const getAreas = async () => {
	const r = await get(ApiEndpoint.Areas);
	return r[0];
};
